import React, { useEffect, useState } from 'react';
import { isEqual } from 'lodash';

import {
  GetSurveyDto,
  GetSurveyEmailContentDto,
} from '../../../common/pokCore/autogenerated/pokApiClient';
import { SurveyEditorTabs } from '../../containers/SurveyEditorView/SurveyEditorView';
import { usePokCore } from '../../../common/hooks/usePokCore';
import { useNotifications } from '../../../common/hooks/useNotifications';

import { SurveyEmailTemplate } from './SurveyEmailTemplate';

interface SurveyEmailDataProps {
  survey?: GetSurveyDto;
  surveyId?: string;
  isLocked?: boolean;
  isOtherTabInEditMode?: boolean;
  setNotSavedTab: (tab: SurveyEditorTabs | undefined) => void;
}

export const SurveyEmailData: React.FC<SurveyEmailDataProps> = props => {
  const pok = usePokCore();
  const notifications = useNotifications();
  const [surveyEmailData, setSurveyEmailData] = useState<
    GetSurveyEmailContentDto | undefined
  >(undefined);

  useEffect(() => {
    if (!props.surveyId) {
      setSurveyEmailData(undefined);
      return;
    }

    if (!props.survey?.emailBody || !props.survey?.emailBodyEn) {
      pok.surveys
        .getEmailTemplate(props.surveyId)
        .then(data => {
          setSurveyEmailData(data);
        })
        .catch(error => {
          notifications.caughtError(error);
          setSurveyEmailData({
            emailSubject: '',
            emailSubjectEn: '',
            emailBody: '',
            emailBodyEn: '',
          });
        });
    } else {
      const newData = {
        emailSubject: props.survey?.emailSubject || '',
        emailSubjectEn: props.survey?.emailSubjectEn || '',
        emailBody: props.survey?.emailBody || '',
        emailBodyEn: props.survey?.emailBodyEn || '',
      };
      setSurveyEmailData(prevData => {
        if (isEqual(prevData, newData)) {
          return prevData;
        }
        return newData;
      });
    }
  }, [props.surveyId, props.survey, pok.surveys, notifications]);

  if (!props.surveyId || !props.survey) {
    return null;
  }

  if (!surveyEmailData) {
    return null;
  }

  return (
    <SurveyEmailTemplate
      surveyId={props.surveyId}
      isLocked={props.isLocked}
      originalEmailData={surveyEmailData}
      setNotSavedTab={props.setNotSavedTab}
      isOtherTabInEditMode={props.isOtherTabInEditMode}
    />
  );
};
